var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgOutlineCalendar = function SvgOutlineCalendar(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 3H19.5V1H17.5V3H7.5V1H5.5V3H4.5C3.4 3 2.5 3.9 2.5 5V21C2.5 22.1 3.4 23 4.5 23H20.5C21.6 23 22.5 22.1 22.5 21V5C22.5 3.9 21.6 3 20.5 3ZM20.5 21H4.5V10H20.5V21ZM20.5 8H4.5V5H20.5V8Z",
    fill: "#8B90A0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOutlineCalendar);
export { ForwardRef as ReactComponent };